module.exports = __webpack_public_path__ + "media/audio101.0d7d5554.mp3";